export default "__VITE_ASSET__qwGC7OnG__"